/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AppliedContractTermsResourceContractTermsInner } from './';
import {
    AppliedContractTermsResourceContractTermsInnerFromJSON,
    AppliedContractTermsResourceContractTermsInnerFromJSONTyped,
    AppliedContractTermsResourceContractTermsInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface AppliedContractTermsResource
 */
export interface AppliedContractTermsResource {
    /**
     * 
     * @type {Array<AppliedContractTermsResourceContractTermsInner>}
     * @memberof AppliedContractTermsResource
     */
    contractTerms?: Array<AppliedContractTermsResourceContractTermsInner>;
    /**
     * 
     * @type {string}
     * @memberof AppliedContractTermsResource
     */
    freelancerTerms?: string;
}

/**
 * Check if a given object implements the AppliedContractTermsResource interface.
 */
export function instanceOfAppliedContractTermsResource(value: object): value is AppliedContractTermsResource {
    return true;
}

export function AppliedContractTermsResourceFromJSON(json: any): AppliedContractTermsResource {
    return AppliedContractTermsResourceFromJSONTyped(json, false);
}

export function AppliedContractTermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppliedContractTermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'contractTerms': json['contractTerms'] == null ? undefined : ((json['contractTerms'] as Array<any>).map(AppliedContractTermsResourceContractTermsInnerFromJSON)),
        'freelancerTerms': json['freelancerTerms'] == null ? undefined : json['freelancerTerms'],
    };
}

export function AppliedContractTermsResourceToJSON(value?: AppliedContractTermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contractTerms': value['contractTerms'] == null ? undefined : ((value['contractTerms'] as Array<any>).map((v) => AppliedContractTermsResourceContractTermsInnerToJSON(v))),
        'freelancerTerms': value['freelancerTerms'],
    };
}

